import React from "react";
import { reportError } from "@/lib/errorReporter";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError({
      message: error?.message || "Render error",
      stack: `${error?.stack || ""}\n${info?.componentStack || ""}`,
      path: typeof window !== "undefined" ? window.location.pathname : "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-pula-bg" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="w-16 h-16 rounded-full bg-pula-green/10 grid place-items-center mx-auto">
              <img src="/pula-guide.png" alt="" className="w-12 h-12 rounded-full object-cover" />
            </div>
            <h1 className="mt-4 font-heading font-extrabold text-2xl text-pula-ink">Something went wrong</h1>
            <p className="mt-2 text-sm text-pula-inksoft font-body">
              Sorry about that — our team has been notified automatically. Please try again.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => { window.location.href = "/"; }}
              className="mt-5 px-5 py-2.5 rounded-full bg-pula-green text-white text-sm font-heading font-bold hover:bg-pula-greenhover transition-colors">
              Back to home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
